module.exports = __webpack_public_path__ + "img/a3b8332ce9467a2fbac2ad19ba39ec29.png";